// import { QueryClient } from '@tanstack/react-query'
import { createRouter as createTanStackRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { DefaultCatchBoundary } from './components/DefaultCatchBoundary'
import { NotFound } from './components/NotFound'

// NOTE: Most of the integration code found here is experimental and will
// definitely end up in a more streamlined API in the future. This is just
// to show what's possible with the current APIs.

export function getRouter ()
{
    // const queryClient = new QueryClient({
    //     defaultOptions: {
    //         queries: {
    //             gcTime: 1000 * 60 * 5,
    //             staleTime: 1000 * 60 * 5,
    //             enabled: typeof window === 'undefined',
    //         }
    //     }
    // })
    //
    // return routerWithQueryClient(createTanStackRouter({
    //     routeTree,
    //     context: { queryClient },
    //     defaultPreload: 'intent',
    //     defaultErrorComponent: DefaultCatchBoundary,
    //     defaultNotFoundComponent: () => <NotFound />,
    //     scrollRestoration: true,
    // }), queryClient)

    return createTanStackRouter({
        routeTree,
        defaultPreload: 'intent',
        defaultErrorComponent: DefaultCatchBoundary,
        defaultNotFoundComponent: () => <NotFound />,
        scrollRestoration: true,
    })
}

declare module '@tanstack/react-router'
{
    interface Register
    {
        router: ReturnType<typeof getRouter>
    }
}
